import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Profile from "../Profile/Profile";
import hand_downward from "../public/assets/img/hand-downward.png";
import start from "../public/assets/img/start.png";
import form from "../public/assets/img/form.png";
import vcard from "../public/assets/img/vcard.png";
import vcard_benefits from "../public/assets/img/vcard-benefits.svg";
import { updateSubscriptionStatus } from "../../utils/subscription";
import MetaHelmet from "../MetaHelmet";

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  // const [businessCount, setBusinessCount] = useState(0);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/");
        return;
      }

      try {
        const userResponse = await axios.get(`${API_BASE_URL}dashboard`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const response = await axios.get(`${API_BASE_URL}profile-information`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        setUserData(userResponse.data);

        // const businessResponse = await axios.get(`${API_BASE_URL}/business-list`, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });

        // if (Array.isArray(businessResponse.data.business)) {
        //   setBusinessCount(businessResponse.data.business.length);
        // }

      } catch (err) {
        if (
          err.response &&
          err.response.status === 403 &&
          err.response.data.login_subscription === "Expired"
        ) {

          updateSubscriptionStatus("Expired");
          window.dispatchEvent(new Event("storage"));
          return;
        }
        setError("Failed to fetch dashboard data");
        console.error(err);
        localStorage.removeItem("token");
        navigate("/");
      }
    };

    fetchData();
  }, [navigate, API_BASE_URL]);

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
      <MetaHelmet title={`Local Shouts | Dashboard`} />
      <div className="container" id="dashboard">
        <div className="d-flex flex-column dashboard-content mt-4">

          <div className="d-flex gap-3 upper-section">
            <div className="hero-section d-flex flex-column">
              <div className="title-section d-flex flex-column">
                <div className="title">Welcome to <span>LocalShouts</span> Admin</div>
                <div className="subtitle mt-3">🚀Create VCards Instantly <br /> Generate professional digital business cards in just one click</div>
              </div>

              <div className="bottom-section text-center">
                <Link to="/business/create" className="create-vcard-btn">Get Started Now</Link>
              </div>
            </div>

            <div className="d-flex benefits white-box-shadow">
              <div className="d-flex flex-column">
                <div className="section-heading">VCard Benefits</div>
                <ul className="list flex-column">
                  <li className="d-flex"><i class="icon-tick"></i>&nbsp;<div>Quick and hassle-free creation</div></li>
                  <li className="d-flex"><i class="icon-tick"></i>&nbsp;<div>Shareable digital format</div></li>
                  <li className="d-flex"><i class="icon-tick"></i>&nbsp;<div>Enhance your business presence</div></li>
                </ul>
              </div>
              <div className="ms-auto my-auto vc-benefit-img-cnt">
                <img src={vcard_benefits} className="side-img" alt="Vcard benefit image" />
              </div>
            </div>
          </div>

          <div className="how-it-works-container">
            <div className="how-it-works">
              <div className="section-heading">How It Works</div>
              <div className="list d-flex">

                <div className="steps-card-container">
                  <div className="steps-card d-flex flex-column white-box-shadow">
                    <div className="icon"><img src={start} /></div>
                    <div className="heading">Start creating a VCard</div>
                    <div className="desc">Click the button below to start creating a VCard.</div>
                  </div>
                </div>
                <div className="steps-card-container">
                  <div className="steps-card d-flex flex-column white-box-shadow">
                    <div className="icon"><img src={form} /></div>
                    <div className="heading">Fill details</div>
                    <div className="desc">Fill in the required business details.</div>
                  </div>
                </div>
                <div className="steps-card-container">
                  <div className="steps-card d-flex flex-column white-box-shadow">
                    <div className="icon"><img src={vcard} /></div>
                    <div className="heading">Generate VCard</div>
                    <div className="desc">Instantly generate and share your digital business card.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Dashboard;
